// src/pages/setup/components/services/customerBuildingService.js
import API_BASE_URL from "../../../../../Constants";

// Fetch all building options.
export const fetchAllBuildings = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/setup/buildings/all`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });
    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Failed to fetch buildings:", error);
    throw error;
  }
};

// Fetch buildings assigned to a specific customer.
export const fetchAssignedBuildings = async (customerId) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/setup/customers/${customerId}/buildings`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      }
    );
    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Failed to fetch assigned buildings:", error);
    throw error;
  }
};

export const getBuildingById = async (buildingId) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/setup/buildings/${buildingId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      }
    );
    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Failed to fetch building by ID:", error);
    throw error;
  }
};

// Associate an existing building with a customer.
export const addBuilding = async (customerID, buildingID) => {
  const response = await fetch(
    `${API_BASE_URL}/api/setup/buildings/${buildingID}/customer`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({ customerID }),
    }
  );
  if (!response.ok) throw new Error("Failed to add building");
  return response.json();
};

// Remove a building association from a customer.
export const removeBuilding = async (customerId, buildingID) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/setup/buildings/${buildingID}/customer`,
      {
        method: "PUT",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ customerID: null }),
      }
    );
    if (!response.ok) {
      throw new Error(await response.text());
    }
    return response.json();
  } catch (error) {
    console.error("Failed to remove building:", error);
    throw error;
  }
};

// Update an individual building's data.
export const updateBuilding = async (buildingId, buildingData) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/setup/buildings/${buildingId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(buildingData),
      }
    );
    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }
    const updatedBuilding = await response.json();
    return updatedBuilding;
  } catch (error) {
    console.error("Failed to update building:", error);
    throw error;
  }
};

// Create a new building record.
export const createNewBuilding = async (buildingData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/setup/buildings`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(buildingData),
    });
    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }
    const responseData = await response.json();
    console.log("Created building:", responseData);
    return responseData;
  } catch (error) {
    console.error("Failed to create building:", error);
    throw error;
  }
};

// Optionally, update multiple buildings for a customer in one call.
export const updateCustomerBuildings = async (data) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/setup/buildings/update-all`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }
  } catch (error) {
    console.error("Failed to update customer buildings:", error);
    throw error;
  }
};
